import React, { useEffect, useState } from "react";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { Textarea } from "../inputs";
import { checkMultiMatch, setDefaultArrayValue } from "../typeahead/lib/check-match";
import { useTempMessage } from "../../../shared/hooks/temp-message";

import "./textarea.scss";

const TextareaList = (props) => {
    const [state, setState] = useState(setDefaultArrayValue(props.defaultValue, [""]));
    const errorMessage = useTempMessage();

    useEffect(() => {
        const isMatch = checkMultiMatch(setDefaultArrayValue(props.defaultValue), state);

        if (!isMatch) {
            setState(setDefaultArrayValue(props.defaultValue));
        }
    }, [props.defaultValue]);

    useEffect(() => {
        const lastIndex = state.length - 1;

        if (state[lastIndex] === "") {
            const $newTextarea = document.getElementById(`textareaList_${props.name}_${lastIndex}`);

            if ($newTextarea) {
                $newTextarea.focus();
            }
        }
    }, [state]);

    const addItem = () => {
        if (_.compact(state).length !== state.length) {
            errorMessage.trigger("Only 1 empty textarea can be created at a time.");

            return;
        }

        setState([...state, ""]);
    };

    const removeItem = (index) => {
        const newState = state.reduce((arr, v, i) => {
            if (i !== index) {
                arr.push(v);
            }

            return arr;
        }, []);

        processUpdate(newState);
    };

    const updateField = (value, index) => {
        const newState = [...state];

        if (index !== -1) {
            newState[index] = value;
        }

        processUpdate(newState);
    };

    const processUpdate = (newState) => {
        const compactedState = _.compact(newState);
        setState(compactedState);

        if (props.updateOnChange) {
            props.updateOnChange(props.name, [...compactedState]);
        }
    };

    const inputs = state.map((v, i) => {
        const appendedName = `${props.name}_${i}`;

        return (
            <div key={`textareaList_${appendedName}`} className="textarea">
                <Textarea
                    id={`textareaList_${appendedName}`}
                    name={`textareaList_${appendedName}`}
                    defaultValue={v}
                    onBlur={(e) => {
                        updateField(e.currentTarget.value, i);
                    }}
                />
                <div
                    className="close"
                    onClick={() => {
                        removeItem(i);
                    }}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </div>
        );
    });

    return (
        <div>
            {inputs}
            <div className="button-group">
                <button className="button -primary" onClick={addItem}>
                    +
                </button>
                <div className="txt-error">{errorMessage.message}</div>
            </div>
        </div>
    );
};

export default TextareaList;
